import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useContext, useState } from "react";
import { FormContext } from "../../../context/FormContext";

function CreativeLabourForm() {
  const { formData, updateForm } = useContext(FormContext);

  const POST_ESTIMATION = 1.626;   // multiplier
  const RPP = '0.50';              // $ per post

  const MAX_POSTS = 100000;    // cap posts at 40M
  const MAX_MINS = 1440;       // cap time ~1 year

  const [local, setLocal] = useState({
    postCount: formData.postCount?.toString() ?? "",
    minsPerPost: formData.minsPerPost?.toString() ?? "",
  });

  const fmtInt = (n) =>
    new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);

  const fmtCurrency = (n) =>
    new Intl.NumberFormat(undefined, { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n);

  // handlers
  const handlePostChange = (e) => {
    let raw = e.target.value.replace(/^0+(?=\d)/, ""); // strip leading zeros
    let num = Number(raw);
    if (num > MAX_POSTS) {
      num = MAX_POSTS;
      raw = String(MAX_POSTS);
    }
    setLocal(p => ({ ...p, postCount: raw }));
    if (!Number.isNaN(num) && raw !== "") {
      updateForm?.({ postCount: num });
    }
  };

  const handleMinsChange = (e) => {
    let raw = e.target.value.replace(/^0+(?=\d)/, ""); // strip leading zeros
    let num = Number(raw);
    if (num > MAX_MINS) {
      num = MAX_MINS;
      raw = String(MAX_MINS);
    }
    setLocal(p => ({ ...p, minsPerPost: raw }));
    if (!Number.isNaN(num) && raw !== "") {
      updateForm?.({ minsPerPost: num });
    }
  };

  // derived values
  const posts = Number(local.postCount) || 0;
  const mins = Number(local.minsPerPost) || 0;

  const estimatedPosts = posts * POST_ESTIMATION;
  const totalHrs = (estimatedPosts * mins)/60;

  return (
    <>
      <div className="contents-main">
        <h1>Your time is money.</h1>
        <div>
          <p>
            Every post is work when Meta sells ads on top of it. We charge Meta an hourly rate for your creative labour.
          </p>

          <div className="" style={{ marginTop: 25 }}>
            <label for="postCount"><b>How many posts are on your Instagram account?</b></label>
            <p style={{fontSize: 13, color: 'grey', marginBottom: 0, marginTop: 5}}>
              (This number represents Grid posts only, we'll multiply by 1.626 to include Reels)
            </p>
            <input
              id="postCount"
              name="postCount"
              type="number"
              min="0"
              max={MAX_POSTS}
              value={local.postCount}
              onChange={handlePostChange}
              style={{ marginTop: 10, outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
            />

          </div>

          <div className="" style={{ marginTop: 25 }}>
            <label for="minsPerPost"><b>How many minutes do you usually spend making each post?</b></label>
            <input
              id="minsPerPost"
              name="minsPerPost"
              type="number"
              min="0"
              max={MAX_MINS}
              value={local.minsPerPost}
              onChange={handleMinsChange}
              style={{ marginTop: 10, outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
            />

          </div>

        </div>
      </div>

      <div className="contents-footer">
        <p className="footer-label">Your Total Labour</p>
        <p className="footer-value">{totalHrs.toFixed(2)} hrs</p>
      </div>
    </>
  );
}
export default CreativeLabourForm;
